module.exports = __webpack_public_path__ + "2ac81e4e8fefd99103944a60c02e807a.svg";